import { AxiosResponse } from "axios";
import { RemoteVideoTrack, VideoTrack } from "twilio-video";
import { IBioDocConfig } from "../../../common/interfaces/IBioDocConfig";
import { getTrack } from "../../../utils/getTrack";
import { showToast } from "../../../utils/showToast";
import useQuery from "../../../utils/useQuery";
import axiosClient from "../../../common/axios/axiosConfig";

interface IResponse {
  success: boolean;
}

export const executeFacialRecognition = (
  bioDocConfig: IBioDocConfig,
  tracks?: RemoteVideoTrack[]
): Promise<IResponse> => {
  const video: HTMLVideoElement | null = document.getElementById(
    "remote-video"
  ) as HTMLVideoElement;
  let base64Image = "";
  let enabled = true;

  if (tracks) {
    const videoTrack = getTrack("camera", tracks) as VideoTrack;
    enabled = videoTrack ? videoTrack.isEnabled : true;
  }

  if (video && enabled) {
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // eslint-disable-next-line no-unused-expressions
    canvas
      .getContext("2d")
      ?.drawImage(video, 0, 0, canvas.width, canvas.height);
    base64Image = canvas.toDataURL();
  }

  return axiosClient
    .post(`/room/facial-recognition/execute`, 
      {
        carteira: bioDocConfig.data.ncart,
        token: bioDocConfig.data.token,
        tokenAmpliId: bioDocConfig.data.tokenAmpliId || "",
        integracao: bioDocConfig.data.integracao || 'biodoc',
        image: base64Image,
        verificante: "Amplimed",
        nmLocal: "Teleatendimento",
        prestCodigo: "",
        prestNome: "",
      },
      {
        headers: {
          Authorization: `Bearer ${useQuery().get("token") || ""}`,
        }
      }
    )
    .then((response: AxiosResponse<IResponse>) => {
      if (!response.data.success) {
        showToast("error", {
          text: "Reconhecimento facial falhou tentaremos novamente em 1 min.",
          showConfirmButton: true,
          confirmButtonText: "OK",
          timer: 10000,
        });
      } else {
        showToast("info", {
          text: "Beneficiário autênticado no reconhecimento facial.",
          showConfirmButton: true,
          confirmButtonText: "OK",
          timer: 10000,
        });
      }
      return response.data;
    }).catch((error) => {
      if (error.response?.status >= 400 && error.response?.status <= 404) {
        showToast("error", {
          text: "Reconhecimento facial falhou. Tentaremos novamente em 1 min.",
          showConfirmButton: true,
          confirmButtonText: "OK",
          timer: 10000,
        });
        return { success: false };
      }
  
      throw error;
    });
};
